import { useTranslation } from 'react-i18next'
import { useWsStatus } from '@/hooks/useWsStatus'
import { cn } from '@/lib/cn'
import type { WsStatus } from '@/services/websocket'

function resolveTone(status: WsStatus): {
  labelKey: string
  dot: string
  pulse: boolean
} {
  switch (status) {
    case 'open':
      return { labelKey: 'status.connected', dot: 'bg-bid', pulse: true }
    case 'connecting':
      return {
        labelKey: 'status.connecting',
        dot: 'bg-accent',
        pulse: true,
      }
    case 'error':
    case 'closed':
      return { labelKey: 'status.reconnecting', dot: 'bg-danger', pulse: true }
    default:
      return { labelKey: 'status.offline', dot: 'bg-terminal-muted', pulse: false }
  }
}

export function ConnectionBadge({ className }: { className?: string }) {
  const { t } = useTranslation('common')
  const status = useWsStatus()
  const tone = resolveTone(status)

  return (
    <div
      className={cn(
        'inline-flex h-7 items-center gap-1.5 rounded-sm border border-terminal-border/40',
        'bg-terminal-surface/80 px-2 text-[10px] font-medium uppercase tracking-wide',
        'text-terminal-muted',
        className,
      )}
      title={t(tone.labelKey)}
    >
      <span
        className={cn(
          'inline-block h-1.5 w-1.5 rounded-full',
          tone.dot,
          tone.pulse && 'animate-[pulse-dot_1.4s_ease-in-out_infinite]',
        )}
      />
      <span className="hidden sm:inline">{t(tone.labelKey)}</span>
    </div>
  )
}
